import { MARK_PAYMENTS_AS_PAID } from './constants';

import fetchWithRefresh from './fetchWithRefresh';

export interface MarkPaymentAsPaid {
    success?: string;
    error?: string;
}

export default ({ visitId }: { visitId: string }): Promise<MarkPaymentAsPaid> => {
    const params = {
        is_id: visitId,
    };
    return fetchWithRefresh(MARK_PAYMENTS_AS_PAID, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed markPaymentAsPaid');
        }
    });
};
